import React from "react";
import { useTranslation } from "react-i18next";
import EditableTextSection from "../../components/ui/EditableTextSection";

const StaticPage = () => {
  const { t } = useTranslation();

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
      <h1 className="mb-6 text-2xl font-bold text-foreground">{t("static_title")}</h1>

      <div className="space-y-6">
        <EditableTextSection
          apiKey="about_us"
          title={t("static_about")}
        />

        <EditableTextSection
          apiKey="term_of_use"
          title={t("static_terms")}
        />

        <EditableTextSection
          apiKey="privacy_policy"
          title={t("static_privacy")}
        />
      </div>
    </div>
  );
};

export default StaticPage;
